export const BETTING_OPPORTUNITY_WIDGET = {
  ACTION_TYPES: {
    bettingNavigationClick: 'bettingNavigationClick',
    changeCurrentIndex: 'changeCurrentIndex'
  },
  BET_TYPE: {
    trend: 'trend',
    insight: 'insight',
    none: 'none'
  },
  GAME_CARD_HEIGHTS: {
    mobile: 72,
    desktop: 80
  }
};